/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `LogoUploadField` for the Caintra Connect frontend.
 * @module components/AppointmentRegistrationSections/CorporateIdentity/LogoUploadField
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import FileUploadArea from "../../../modals/ProposalCreateModal/FileUploadArea";

const LogoUploadField = ({
  logoFile,
  isUploading,
  isDragging,
  error,
  getFieldValidation,
  missingRequiredFields,
  isMobile,
  onFileChange,
  onDragOver,
  onDragLeave,
  onDrop,
  onClick,
  t,
  styles,
}) => (
  <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
    <label
      className={`${styles.inputLabel} ${
        isMobile ? styles.mobileLogoLabel : ""
      }`}
    >
      {t("components.corporateIdentity.logoLabel")}
      {missingRequiredFields &&
        Object.hasOwn(missingRequiredFields, "logo") && (
          <span className={styles.required}> *</span>
        )}
    </label>
    <div className={styles.fileUploadContainer}>
      <FileUploadArea
        file={logoFile}
        isUploading={isUploading}
        isDragging={isDragging}
        error={
          error ||
          (getFieldValidation && getFieldValidation("logo") ? " " : "")
        }
        onFileChange={onFileChange}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        onClick={onClick}
        reduceHeightForMobile={isMobile}
      />
      <input
        id="logoFileInput"
        type="file"
        onChange={onFileChange}
        className={styles.fileInput}
        style={{ display: "none" }}
      />
    </div>
  </div>
);

export default LogoUploadField;
